import { render, staticRenderFns } from "./TeamOperationsCommunicationModal.vue?vue&type=template&id=20d7a112&"
import script from "./TeamOperationsCommunicationModal.vue?vue&type=script&lang=ts&"
export * from "./TeamOperationsCommunicationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports